import { render, staticRenderFns } from "./TypographyImagesSection.vue?vue&type=template&id=0a08dd41"
import script from "./TypographyImagesSection.vue?vue&type=script&lang=js"
export * from "./TypographyImagesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports